
import React, { useEffect, useState } from 'react'
//imagenes
import entregaIcon from "../../assets/icons/entregaIcon.svg";
import creditoAprovado from "../../assets/icons/creditoAprovado.svg";
import enLineaIcon from "../../assets/icons/enLineaIcon.svg";

const MetodosPago = (props) => {

    useEffect(() => {
    })

    return (
        <div className="content-steeps">
            <div className="steeps">
                <div className="steep-circle">3</div>
                <div className="description">
                    <b>Tercer paso:</b> revisa y/o selecciona un método de pago.
                </div>
            </div>
            <div className="content-carrito scrollSlider">
                <div className="metodoPago-opciones">
                    <div className={'metodoPago-opciones-item ' + (props.metodo == "CT" ? " active" : "")}>
                        <div className="metodoPago-opciones-item-icon">
                            <img src={entregaIcon} alt="" />
                        </div>

                        <div className="metodoPago-opciones-item-text">
                            <h3><b>Pagar contraentrega</b></h3>
                            <p>Pagas cuando recibes el pedido</p>
                        </div>

                        {/* <div className="metodoPago-opciones-item-accion">
                            <button onClick={() => { props.updateMetodo("CT") }}><b>Seleccionar</b></button>
                        </div> */}
                    </div>

                    {/* <div className={'metodoPago-opciones-item ' + (props.metodo == "CA" ? " active" : null)}>
                        <div className="metodoPago-opciones-item-icon">
                            <img src={creditoAprovado} alt="" />
                        </div>

                        <div className="metodoPago-opciones-item-text">
                            <h3><b>Con el crédito aprobado</b></h3>
                            <p>Lorem ipsum dolor sit amect</p>
                        </div>

                        <div className="metodoPago-opciones-item-accion">
                            <button onClick={() => { props.updateMetodo("CA") }}><b>Seleccionar</b></button>
                        </div>
                    </div> */}

                    {/** Pago en linea documentado, si se necesita solo quite el comentado
                    <div className={'metodoPago-opciones-item ' + (props.metodo == "PL" ? " active" : null)}>
                        <div className="metodoPago-opciones-item-icon">
                            <img src={enLineaIcon} alt="" />
                            {
                                //<i className="fa fa-picture-o" aria-hidden="true"></i>
                            }
                        </div>

                        <div className="metodoPago-opciones-item-text">
                            <h3><b>Pago en línea</b></h3>
                            <p>Lorem ipsum dolor sit amect</p>
                        </div>

                        <div className="metodoPago-opciones-item-accion">
                            <button onClick={() => { props.updateMetodo("PL") }}><b>Seleccionar</b></button>
                        </div>
                    </div>
                    **/}

                    <div className="error">
                        <p>{props.error ? props.error : null}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MetodosPago
